import { render, staticRenderFns } from "./DispositionDialog.vue?vue&type=template&id=4a936fa6&scoped=true&lang=pug&"
import script from "./DispositionDialog.vue?vue&type=script&lang=ts&"
export * from "./DispositionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DispositionDialog.vue?vue&type=style&index=0&id=4a936fa6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a936fa6",
  null
  
)

export default component.exports